'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.showFiltersModal = showFiltersModal;
exports.hideFiltersModal = hideFiltersModal;
exports.setStartY = setStartY;
exports.setDoLocation = setDoLocation;
exports.setYear = setYear;
exports.init = init;
exports.loadMoreCUList = loadMoreCUList;
exports.reloadCUList = reloadCUList;
exports.toggleFilter = toggleFilter;
exports.resetFilter = resetFilter;
exports.redirectToCUDetail = redirectToCUDetail;

var _reactRouter = require('react-router');

var t = {
    LOAD_MORE_CULIST: '/subject/culist/LOAD_MORE_CULIST',
    LOAD_MORE_CULIST_SUCCESS: '/subject/culist/LOAD_MORE_CULIST_SUCCESS',
    LOAD_MORE_CULIST_FAIL: '/subject/culist/LOAD_MORE_CULIST_FAIL',

    RELOAD_CULIST: '/subject/culist/RELOAD_CULIST',
    RELOAD_CULIST_SUCCESS: '/subject/culist/RELOAD_CULIST_SUCCESS',
    RELOAD_CULIST_FAIL: '/subject/culist/RELOAD_CULIST_FAIL',

    GET_FILTERS: '/subject/culist/GET_FILTERS',
    GET_FILTERS_SUCCESS: '/subject/culist/GET_FILTERS_SUCCESS',
    GET_FILTERS_FAIL: '/subject/culist/GET_FILTERS_FAIL',

    TOGGLE_FILTER: '/subject/culist/TOGGLE_FILTER',
    SET_SELECTED_SUBJECTS: '/subject/culist/SET_SELECTED_SUBJECTS',
    SET_STARTY: '/subject/culist/SET_STARTY',
    SET_DO_LOCATION: '/subject/culist/SET_DO_LOCATION',
    SET_YEAR: '/subject/culist/SET_YEAR',

    RESET_FILTER: '/subject/culist/RESET_FILTER',

    SHOW_FILTER: '/subject/culist/SHOW_FILTER',
    HIDE_FILTER: '/subject/culist/HIDE_FILTER'
};

var initialState = {
    errorMessage: null,
    selectedSubjects: [],
    filters: [],
    selectedFilters: {},
    pager: {},
    culist: [],
    loading: false,
    isSearched: false,
    isFiltered: false,
    hasInited: false,
    doLocation: false,
    startY: 0,
    year: '',
    showFilters: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case t.LOAD_MORE_CULIST_SUCCESS:
            {
                if (!action.result.data.success) {
                    return state;
                }
                var _res = _extends({}, state, {
                    pager: action.result.data.pager
                });
                _res.culist = _res.culist.concat(action.result.data.data);
                return _res;
            }
        case t.RELOAD_CULIST:
            return _extends({}, state, {
                loading: true
            });
        case t.RELOAD_CULIST_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    pager: null,
                    culist: [],
                    isSearched: true,
                    isFiltered: false,
                    hasInited: true,
                    loading: false
                });
            }
            if (action.params.isFiltered) {
                return _extends({}, state, {
                    pager: action.result.data.pager,
                    culist: action.result.data.data,
                    isSearched: true,
                    isFiltered: true,
                    hasInited: true,
                    loading: false
                });
            }
            return _extends({}, state, {
                pager: action.result.data.pager,
                culist: action.result.data.data,
                isSearched: true,
                isFiltered: false,
                hasInited: true,
                loading: false
            });
        case t.RELOAD_CULIST_FAIL:
            return _extends({}, state, {
                loading: false
            });
        case t.GET_FILTERS_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                filters: action.result.data.data
            });
        case t.TOGGLE_FILTER:
            {
                //copy对象
                var res = JSON.parse(JSON.stringify(state));
                var selectedFilters = res.selectedFilters[action.filterType];
                selectedFilters = selectedFilters ? selectedFilters : [];
                var i = selectedFilters.map(function (sf) {
                    return sf.id;
                }).indexOf(action.filter.id);
                i > -1 ? selectedFilters.splice(i, 1) : selectedFilters.push(action.filter);
                res.selectedFilters[action.filterType] = selectedFilters;
                return _extends({}, state, {
                    selectedFilters: res.selectedFilters
                });
            }
        case t.RESET_FILTER:
            return _extends({}, state, {
                selectedFilters: {},
                isFiltered: false
            });
        case t.SET_SELECTED_SUBJECTS:
            return _extends({}, state, {
                selectedSubjects: action.selectedSubjects
            });
        case t.SET_DO_LOCATION:
            return _extends({}, state, {
                doLocation: action.doLocation
            });
        case t.SET_STARTY:
            return _extends({}, state, {
                startY: action.startY
            });
        case t.SET_YEAR:
            return _extends({}, state, {
                year: action.year
            });
        case t.SHOW_FILTER:
            return _extends({}, state, {
                showFilters: true
            });
        case t.HIDE_FILTER:
            return _extends({}, state, {
                showFilters: false
            });
        default:
            return state;
    }
}
function showFiltersModal() {
    return {
        type: t.SHOW_FILTER
    };
}

function hideFiltersModal() {
    return {
        type: t.HIDE_FILTER
    };
}

function setStartY(y) {
    return {
        type: t.SET_STARTY,
        startY: y
    };
}

function setDoLocation(value) {
    return {
        type: t.SET_DO_LOCATION,
        doLocation: value
    };
}
function setYear(year) {
    return {
        type: t.SET_YEAR,
        year: year
    };
}
function init(selectedSubjects) {
    return function (dispatch, getState) {
        dispatch(_setSelectedSubjects(selectedSubjects));
        dispatch(_getFilters());
    };
}
// export function init(selectedSubjects, year, mustInit = false) {
//     return (dispatch, getState) => {
//         if (mustInit) {
//             dispatch(_setSelectedSubjects(selectedSubjects));
//             dispatch(setYear(year));
//             dispatch(reloadCUList());
//             dispatch(_getFilters());
//             dispatch(setDoLocation(false));
//             dispatch(setStartY(0));
//         } else {
//             if (!getState().subjectCUList.hasInited) {
//                 dispatch(_setSelectedSubjects(selectedSubjects));
//                 dispatch(setYear(year));
//                 dispatch(reloadCUList());
//                 dispatch(_getFilters());
//                 dispatch(setDoLocation(false));
//                 dispatch(setStartY(0));
//             } else {
//                 dispatch(setDoLocation(true));
//             }
//         }
//     }
// }

function _setSelectedSubjects(selectedSubjects) {
    return {
        type: t.SET_SELECTED_SUBJECTS,
        selectedSubjects: selectedSubjects
    };
}

function _loadMoreCUList(params, callback) {
    return {
        types: [t.LOAD_MORE_CULIST, t.LOAD_MORE_CULIST_SUCCESS, t.LOAD_MORE_CULIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/subject/cu_list', params);
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, response) {
                if (callback) {
                    callback();
                }
            }

            return afterSuccess;
        }()
    };
}

function _reloadCUList(params) {
    return {
        types: [t.RELOAD_CULIST, t.RELOAD_CULIST_SUCCESS, t.RELOAD_CULIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/subject/cu_list', params);
            }

            return promise;
        }(),
        params: params
    };
}

function _getFilters() {
    return {
        types: [t.GET_FILTERS, t.GET_FILTERS_SUCCESS, t.GET_FILTERS_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/major/filter');
            }

            return promise;
        }()
    };
}

function _createQuery(_ref) {
    var pager = _ref.pager,
        selectedFilters = _ref.selectedFilters,
        selectedSubjects = _ref.selectedSubjects,
        year = _ref.year;

    if (pager && pager.page && pager.page >= pager.totalPages) {
        return;
    }
    var subjectIds = selectedSubjects.map(function (subject) {
        return subject.id;
    });

    var params = {
        page: pager && pager.page ? pager.page + 1 : 1,
        size: pager && pager.size ? pager.size : 20,
        subjectIds: subjectIds,
        year: year
    };
    params["isFiltered"] = false;
    if (null != params["subjectIds"] && "" != params["subjectIds"]) {
        params["isFiltered"] = true;
    }
    Object.keys(selectedFilters).map(function (key) {
        var filters = selectedFilters[key];
        if (!filters || filters.length == 0) {
            return;
        } else {
            params["isFiltered"] = true;
        }
        var ids = filters.map(function (filter) {
            return filter.id;
        });
        params[key + 'Ids'] = ids;
    });
    return params;
}

function loadMoreCUList(callback) {
    return function (dispatch, getState) {
        var query = _createQuery(getState().subjectCUList);
        if (!!query) {
            dispatch(_loadMoreCUList(query, callback));
        }
    };
}

function reloadCUList() {
    return function (dispatch, getState) {
        var state = getState().subjectCUList;
        state.pager = null;
        var query = _createQuery(state);
        dispatch(_reloadCUList(query));
    };
}

function toggleFilter() {
    var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return {
        type: t.TOGGLE_FILTER,
        filterType: filterType,
        filter: filter
    };
}

function resetFilter() {
    return {
        type: t.RESET_FILTER
    };
}

function redirectToCUDetail(cu, year) {
    return function (dispatch, getState) {
        var selectedSubjects = getState().subjectCUList.selectedSubjects;


        var querySelectedSubjects = [];
        selectedSubjects.map(function (item, index) {
            querySelectedSubjects.push(JSON.stringify(item));
        });

        _reactRouter.browserHistory.push({
            pathname: '/subject/cudetail/' + cu.cuHashId,
            query: {
                year: year,
                province: 11,
                selectedSubjects: querySelectedSubjects,
                cu: JSON.stringify(cu)
            }
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/subject/subjectCUList.js
// module id = 452
// module chunks = 0